
export const toggleShipToSelector = (modalState) => {
  const shipToModal = bootstrap.Modal.getOrCreateInstance(document.getElementById('shipToSelector'))
  if(modalState == 'show'){
    shipToModal.show()
  }else if(modalState == 'hide'){
    shipToModal.hide()
  }
}